import Link from "next/link";
import { Container } from "@/components/layout/container";
import { SignUpForm } from "./sign-up-form";

export default function InscriptionPage() {
  return (
    <section
      className="section min-h-screen"
      style={{
        background:
          "linear-gradient(180deg, rgba(244,215,231,0.96) 0%, rgba(247,225,235,0.94) 38%, rgba(245,210,227,0.92) 100%)",
      }}
    >
      <Container>
        <div className="mx-auto grid max-w-5xl gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div className="max-w-xl">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--accent)]/85">
              Inscription
            </p>

            <h1 className="mt-4 text-5xl leading-[0.96] sm:text-6xl">
              Créer mon espace client
            </h1>

            <p className="mt-6 text-base leading-7 text-[var(--foreground)]/74">
              Créez votre compte pour retrouver votre panier plus facilement,
              suivre vos futures commandes et profiter d’une expérience plus fluide
              sur la boutique.
            </p>

            <div className="mt-8 flex items-center gap-4">
              <p className="text-sm text-[var(--foreground)]/70">
                Vous avez déjà un compte ?
              </p>

              <Link
                href="/connexion"
                className="inline-flex items-center rounded-full bg-[var(--primary)] px-5 py-2 text-sm font-medium !text-white transition hover:opacity-90"
              >
                Se connecter
              </Link>
            </div>
          </div>

          <SignUpForm />
        </div>
      </Container>
    </section>
  );
}